import "./App.css";
import Page from "./pages/page";
import LegalPage from "./pages/LegalPage";
import CookieBanner from "./components/CookieBanner";
import ConsentAnalytics from "./consent/ConsentAnalytics";
import { ConsentProvider } from "./consent/ConsentContext";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { legalSlugs } from "./text/legal";

function App() {
  return (
    <div className="">
      <ConsentProvider>
        <BrowserRouter>
          <Routes>
            <Route index element={<Page />} />
            <Route path="/:lang" element={<Page />} />
            <Route path="/:lang/:slug" element={<LegalRoute />} />
          </Routes>
          <CookieBanner />
          <ConsentAnalytics />
        </BrowserRouter>
      </ConsentProvider>
    </div>
  );
}

// Rezolvă pagina juridică în funcție de slug-ul din ruta :lang
const LegalRoute = () => {
  const { lang, slug } = useParams();
  const types = ["privacy", "terms", "cookies"];
  const language = legalSlugs[lang] ? lang : "ro";
  let type = null;
  for (const t of types) {
    if (legalSlugs[language][t] === slug) {
      type = t;
      break;
    }
  }
  if (!type) return <Page />;
  return <LegalPage type={type} />;
};

export default App;
